import { memo } from "react";
import { Accordion as MuiAccordion, AccordionDetails, AccordionProps, AccordionSummary, Grid2, IconButton, SxProps, Typography } from "@mui/material";
import { icon } from "@/app/style/icons";

interface AccordionPropsNew extends AccordionProps {
    title: string;
    subtitle?: string;
    details?: string;
    hideExpandIcon?: boolean;
    isHeader?: boolean;
    sx?: SxProps;
}

const Accordion = memo(({ title, subtitle, details, children, isHeader, hideExpandIcon, sx, ...props }: AccordionPropsNew) => {
    return (
        <MuiAccordion sx={{ background: "solid", boxShadow: "none", ...sx }} {...props}>
            <AccordionSummary
                expandIcon={
                    <IconButton size={"small"} disabled={hideExpandIcon}>
                        {hideExpandIcon ? (
                            <Typography variant={"h5"} fontSize={"0.8rem"} fontWeight={600}>
                                Info
                            </Typography>
                        ) : (
                            <icon.dropdown sx={{ fontSize: "1.5rem", color: "semantic.icon.default" }} />
                        )}
                    </IconButton>
                }
            >
                <Grid2 container size={12} alignItems={"center"}>
                    <Grid2 container size={"grow"} spacing={1} alignItems={"baseline"}>
                        <Grid2>
                            <Typography fontSize={isHeader ? "0.9rem" : "0.98rem"} fontWeight={isHeader ? 600 : undefined}>
                                {title}
                            </Typography>
                        </Grid2>

                        {subtitle && (
                            <Grid2>
                                <Typography fontSize={"0.75rem"} color={"textDisabled"}>
                                    {subtitle}
                                </Typography>
                            </Grid2>
                        )}
                    </Grid2>

                    {children && <Grid2>{children}</Grid2>}
                </Grid2>
            </AccordionSummary>

            {details && (
                <AccordionDetails>
                    <Typography>{details}</Typography>
                </AccordionDetails>
            )}
        </MuiAccordion>
    );
});

export default Accordion;
